"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetTypeBase = void 0;
var rxjs_1 = require("rxjs");
var DashboardEventBus_1 = require("./DashboardEventBus");
var WidgetTypeBase = (function () {
    function WidgetTypeBase(widgetType) {
        var _this = this;
        this._widgetType = widgetType;
        console.debug("Script for widget type loaded: ".concat(this.constructor.name, " ").concat(this._widgetType));
        this._widgetChangeContentSubscription = DashboardEventBus_1.DashboardEventBus.onWidgetChangeContent()
            .pipe((0, rxjs_1.map)(function (subject) {
            var $widgetContainerElement = $('.grid-stack').find("[gs-id=\"".concat(subject.widgetId, "\"]"));
            return { subject: subject, $widgetContainerElement: $widgetContainerElement };
        }), (0, rxjs_1.filter)(function (_a) {
            var subject = _a.subject, $widgetContainerElement = _a.$widgetContainerElement;
            return _this._widgetType === subject.widgetType && $widgetContainerElement.length === 1;
        }), (0, rxjs_1.switchMap)(function (_a) {
            var subject = _a.subject, $widgetContainerElement = _a.$widgetContainerElement;
            return (0, rxjs_1.of)({ subject: subject, $widgetContainerElement: $widgetContainerElement });
        }))
            .subscribe(function (_a) {
            var subject = _a.subject, $widgetContainerElement = _a.$widgetContainerElement;
            console.debug("Widget content changed for type '".concat(_this._widgetType, "' and id ").concat(subject.widgetId));
            _this.onWidgetChangeContent(subject.widgetId, $widgetContainerElement);
        });
        (0, rxjs_1.fromEvent)(window, 'beforeunload').subscribe(function () {
            console.debug("Script for widget type destroyed: ".concat(_this._widgetType));
            _this._widgetChangeContentSubscription.unsubscribe();
        });
    }
    return WidgetTypeBase;
}());
exports.WidgetTypeBase = WidgetTypeBase;
